var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{class:{'no-click' : _vm.uc},attrs:{"href":_vm.link,"target":"_blank"}},[_c('div',{staticClass:"toy-button",class:{'under-construction' : _vm.uc}},[_c('div',{staticClass:"button-text"},[_vm._v("\n      "+_vm._s(_vm.text)+"\n    ")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2d6fb8d0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Controlls/Button.vue
// module id = null
// module chunks = 